import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FirebaseService } from '../service/firebase.service'
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
@Injectable({
  providedIn: 'root'
})
export class AuthrolebasedGuard implements CanActivate  {

  constructor(private afAuth: AngularFireAuth, private afs: AngularFirestore, private router: Router, private firebaseService: FirebaseService) {
  }



    canActivate (next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {

//console.log(this.firebaseService.getLocalUser())
      if (this.afAuth.authState != null && this.firebaseService.user.role == 'admin')
        return true
      else
        this.router.navigate([''])

}


}
